export default "__VITE_ASSET__Cr3N9Wdl__"